import { Messages } from '../../codegen/Localize';
import { Formatters} from '../../codegen/Localize';
import {
  simpleActionErrorMsg,
  simpleActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';
import { ExtractTasks } from '../../extract/resources/ExtractTasks';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { L10n } from '../../ts/L10n/L10n';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { Set } from '../../ts/models/Set';

function execute(extractTasks: Set<IExtractTaskInfo>): Promise<IResult> {

  let description: string;
  const extractTaskCount = extractTasks.size();

  if (extractTaskCount === 1) {
    const extractTask = extractTasks.first();
    if (extractTask.datasource) {
      description = Messages.extractTaskForDataSourceRunPrompt({DATASOURCE_NAME: L10n.elideIfLong(extractTask.datasource.name)
      });
    } else if (extractTask.workbook) {
      description = Messages.extractTaskForWorkbookRunPrompt({WORKBOOK_NAME: L10n.elideIfLong(extractTask.workbook.name)});
    } else if (extractTask.virtualConnection) {
      description = Messages.extractTaskForVirtualConnectionRunPrompt({VIRTUAL_CONNECTION_NAME: L10n.elideIfLong(extractTask.virtualConnection.name)});
    } else {
      description = Messages.extractTasksRunPrompt({ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)});
    }
  }

  else {
    description = Messages.extractTasksRunPrompt({ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)});
  }

  const dialogConfig = openReactConfirmationDialog<void,IResult>(
    {
      title: Messages.runNow(),
      actionName: Messages.runNowConfirmButton(),
      action: () => ExtractTasks.run(extractTasks.keys()),
      message: description,
      paramsForAction: undefined,
      dialogWidth: TabDialogWidth.width375px
    });

  dialogConfig.result.then((result: IResult) => {
    ContentActionNotification.displaySingleToastForResult({
      items: extractTasks,
      errors: result.errors,
      successMsg: simpleActionSuccessMsg(Messages.extractTasksRunSuccess),
      errorMsg: simpleActionErrorMsg(Messages.extractTasksRunError),
    });
  });

  return dialogConfig.result;

}

export const RunExtractTasksAction = {
  execute
};

export type RunExtractTasksAction = typeof RunExtractTasksAction;
